import { FormControl, Validators } from '@angular/forms';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { InputGeneral } from '../../inputs/input-general/input-general';
import { MatButtonModule } from '@angular/material/button';
import { CatalogsService } from '../../services/catalogs.service';
import { ConnectivityType } from '../../models/catalogs/catalogs-model';
import { InputGeneralSelectComponent } from '../../inputs/input-general-select/input-general-select.component';
import { GeneralService } from '../../services/general.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-filter-general',
  imports: [MatIcon, InputGeneral, MatButtonModule, InputGeneralSelectComponent, TranslateModule],
  templateUrl: './filter-general.html',
  styleUrl: './filter-general.css',
})
export class FilterGeneral {
  public connectivityType: ConnectivityType[] = [];

  public SearchField = new FormControl('', Validators.required);
  public SearchFieldValue = new FormControl('', Validators.required);

  public Sort = new FormControl('', Validators.required);
  public SortDirections = new FormControl('', Validators.required);

  public statusSelected = 0;
  public SearchFields = [
    {
      Value: 'Partner',
      Text: 'Socio',
    },
    {
      Value: 'Customer',
      Text: 'Temática',
    },
    {
      Value: 'Priority',
      Text: 'Prioridad',
    },
    {
      Value: 'Site',
      Text: 'Plaza',
    },
    {
      Value: 'Status',
      Text: 'Estatus de punto de conexión',
    },
    {
      Value: 'LocationName',
      Text: 'Punto de conexión',
    },
    {
      Value: 'Key',
      Text: 'ID',
    },
    {
      Value: 'Zone',
      Text: 'Zona',
    },
  ];

  public orderSort = [
    {
      Value: 'CreateDate',
      Text: 'Fecha de creación',
    },
    {
      Value: 'StartDate',
      Text: 'Fecha de inicio',
    },
  ];
  public orderSortAux = [
    {
      Value: 'Id',
      Text: 'Nº de Servicio',
    },
    {
      Value: 'Priority',
      Text: 'Tipo de Conexión',
    },
    {
      Value: 'Status',
      Text: 'Estado',
    },
    {
      Value: 'LocationName',
      Text: 'Punto de conexión',
    },
    {
      Value: 'Key',
      Text: 'ID',
    },
  ];
  public SortDirectionsArray = [
    {
      Value: 'Asc',
      Text: 'Asc',
    },
    {
      Value: 'Desc',
      Text: 'Desc',
    },
  ];
  constructor(
    public dialog: MatDialog,
    public catalogsService: CatalogsService,
    public generalService: GeneralService,
    public dialogRef: MatDialogRef<FilterGeneral>,
  ) {
    this.getConnectivityType();
  }

  ngOnInit() {
    const urlParams = new URLSearchParams(window.location.search);
    const status = urlParams.get('statusSelected');

    if (status !== null) {
      this.statusSelected = Number(status);
    }
    this.SearchField.setValue(
      localStorage.getItem('locationFilters')
        ? JSON.parse(localStorage.getItem('locationFilters') || '{}').SearchField
        : '',
    );
    this.SearchFieldValue.setValue(
      localStorage.getItem('locationFilters')
        ? JSON.parse(localStorage.getItem('locationFilters') || '{}').SearchFieldValue
        : '',
    );
    this.Sort.setValue(
      localStorage.getItem('locationFilters')
        ? JSON.parse(localStorage.getItem('locationFilters') || '{}').Sort
        : '',
    );
    this.SortDirections.setValue(
      localStorage.getItem('locationFilters')
        ? JSON.parse(localStorage.getItem('locationFilters') || '{}').SortDir
        : '',
    );
  }

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public emitModalLocation(): void {
    localStorage.setItem(
      'locationFilters',
      JSON.stringify({
        Sort: this.Sort.value,
        SortDir: this.SortDirections.value,
        SearchField: this.SearchField.value,
        SearchFieldValue: this.SearchFieldValue.value,
      }),
    );

    this.generalService.emitFilterLocation.emit({
      Sort: this.Sort.value || undefined,
      SortDir: this.SortDirections.value || undefined,
      SearchField: this.SearchField.value || undefined,
      SearchFieldValue: this.SearchFieldValue.value || undefined,
    });
    this.dialogRef.close(null);
  }

  public emitModalTiket(): void {
    this.generalService.emitFilterTiket.emit();
    this.dialogRef.close(null);
  }

  public clearFilters(): void {
    this.SearchField.reset();
    this.SearchFieldValue.reset();
    this.Sort.reset();
    this.SortDirections.reset();

    this.generalService.emitFilterLocation.emit({
      Sort: undefined,
      SortDir: undefined,
      SearchField: undefined,
      SearchFieldValue: undefined,
    });
    localStorage.removeItem('locationFilters');
    this.dialogRef.close(null);
  }

  public getConnectivityType(): void {
    this.catalogsService.getConnectivityType().subscribe((response) => {
      if (response && response.Data) {
        this.connectivityType = response.Data;
      }
    });
  }
}
